import FullPageMapModal from 'js/components/global/fullPageModal';
import CreateTerritoryMap from 'js/components/userFavorites/savedTerritories/CreateTerritoryMap';
import FullPageModalContext from 'js/components/context/FullPageModalContext';
import MapContext from '../../context/MapContextProvider';

const TerritoryMapModal = (props) => {
    return (
        <FullPageModalContext>
            {props.children}
            <FullPageMapModal>
                <MapContext>
                    <CreateTerritoryMap />
                </MapContext>
            </FullPageMapModal>
        </FullPageModalContext>
    );
}

export default TerritoryMapModal;
